var Marionette = require('backbone.marionette');

var ContactsSelectView = Marionette.View.extend({
    template: require('../../templates/common/contacts-select-view.html'),

    ui: {
        contact: '.contact'
    },

    events: {
        'click @ui.contact': 'onContactSelected'
    },

    templateContext: function () {
        var that = this;
        return {
            title: that.title,
            contacts: _.sortBy(that.contacts, function (contact) {
                return contact.type + contact.data;
            }),
            style: "margin-right: 10px;" + that.style,
            generatedElNameFromContact: that.generatedElNameFromContact,
            generatedTitleFromContact: function (contact) {
                return contact.type + ", " + contact.data;
            }
        }
    },

    initialize: function (options) {
        this.title = options.title || 'Add contact from';
        this.contacts = options.contacts || [];
        this.tag = options.tag;
        this.style = options.style;
    },

    onRender: function () {
    },

    generatedElNameFromContact: function (contact) {
        return contact.type + "_" + contact.data;
    },

    onContactSelected: function (e) {
        var that = this;
        var name = e.target.name;
        var selectedContact = _.find(that.contacts, function (contact) {
            return name === that.generatedElNameFromContact(contact);
        });

        if (selectedContact)
            that.triggerMethod("contact:selected:from:contacts:list", {contact: selectedContact, tag: this.tag});
    },

    elFromContact: function (contact) {
        var elSelector = "[name='" + this.generatedElNameFromContact(contact) + "']";
        return $(elSelector);
    },

    showContactItem: function (contact) {
        this.elFromContact(contact).show();
    },

    hideContactItem: function (contact) {
        this.elFromContact(contact).hide();
    }

});

module.exports = ContactsSelectView;


//////////////////
// WEBPACK FOOTER
// ./app/views/common/contacts-select-view.js
// module id = 279
// module chunks = 0